import { phoneCodes } from './phoneCodes';

export const formatPhone = (phone, location) => {
	const phoneData = phone.replace(/[^0-9]/g, '');
	let formattedPhone;

	if (phone.search(/^8800/) >= 0) {
		formattedPhone = phoneData.replace(
			/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
			'$1 ($2) $3-$4-$5'
		);
	} else if (phoneData.search(/^79/) >= 0 && phoneData.length >= 10) {
		formattedPhone = phoneData.replace(
			/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/,
			'+$1 ($2) $3-$4-$5'
		);
	} else {
		const currentPhoneCodes =
			location && phoneCodes[location.federalSubject]?.cities[location.city];
		let regex;
		let mask;

		if (currentPhoneCodes) {
			const activePhoneCode = Array.isArray(currentPhoneCodes)
				? currentPhoneCodes?.find(
						(item) => phoneData.search(new RegExp(`(^7${item})`)) !== -1
				  )
				: currentPhoneCodes;

			const totalDigitNumber = phoneData.replace(
				new RegExp(`(\\d)(${activePhoneCode})`),
				''
			).length;

			switch (totalDigitNumber) {
				case 5:
					regex = new RegExp(`(\\d)(${activePhoneCode})(\\d)(\\d{2})(\\d{2})`);
					break;
				case 7:
					regex = new RegExp(
						`(\\d)(${activePhoneCode})(\\d{3})(\\d{2})(\\d{2})`
					);
					break;
				default:
					regex = new RegExp(
						`(\\d)(${activePhoneCode})(\\d{2})(\\d{2})(\\d{2})`
					);
			}

			mask = '+$1 ($2) $3-$4-$5';
		} else {
			regex = /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/;
			mask = '+$1 ($2) $3-$4-$5';
		}

		formattedPhone = phoneData.replace(regex, mask);
	}

	return formattedPhone;
};
